import { useState } from "react";
import { FileUpload } from "../arc/components/file-upload/file-upload";

/**
 * One upload section of the brief form, built on Arc's FileUpload. Files are validated here (type, size, count) and
 * handed to the form as plain File objects; they go up with the form submission, so no onUpload is needed.
 * Rejected files stay listed with their reason and are never passed on.
 */
export default function BriefUploadField({
  eyebrow,
  className = "gallery-upload",
  label,
  description,
  accept,
  maxSize,
  multiple = true,
  maxFiles,
  noun = "files",
  initialFiles = [],
  onFilesChange,
}) {
  // The form unmounts this section when you move between steps; seed from the files it already holds.
  const [items, setItems] = useState(() =>
    initialFiles.map((file, i) => ({
      id: `${file.name}-${file.size}-${file.lastModified}-${i}`,
      file,
    })),
  );
  const limitMessage = maxFiles ? `Up to ${maxFiles} ${noun} max.` : null;

  function handleChange(next) {
    let valid = 0;
    const limited = next.map((item) => {
      const base =
        limitMessage && item.error === limitMessage
          ? { ...item, error: undefined }
          : item;
      if (base.error) return base;
      valid += 1;
      return maxFiles && valid > maxFiles
        ? { ...base, error: limitMessage }
        : base;
    });
    setItems(limited);
    onFilesChange(
      limited.filter((item) => !item.error).map((item) => item.file),
    );
  }

  return (
    <div className={className}>
      <div className="brief-eyebrow">{eyebrow}</div>
      <FileUpload
        accept={accept}
        maxSize={maxSize}
        multiple={multiple}
        label={label}
        description={description}
        value={items}
        onChange={handleChange}
      />
    </div>
  );
}
